<form [formGroup]="form" *ngIf="legend">
  <div class="form-field check-field">
    <span class="checkbox-icon">
      <input type="checkbox" formControlName="show" id="showlegend" />
      <label class="inline-icon icon-editor-checkbox-light-unchecked" for="showlegend"> Show legend </label>
    </span>
  </div>
  <div>
    <mode-format-dropdown-list
      [label]="'Position'"
      [menuItems]="legendPositions"
      [selected]="currentPosition"
      (selectedChange)="selectPosition($event)"
    ></mode-format-dropdown-list>
  </div>
  <div class="title-form-field">
    <div class="form-field check-field">
      <span class="checkbox-icon">
        <input type="checkbox" formControlName="showTitle" id="showLegendTitle" />
        <label class="inline-icon icon-editor-checkbox-light-unchecked" for="showLegendTitle"> Show title </label>
      </span>
    </div>
    <label class="label-form-control">
      Title
      <input
        class="form-control form-control-sm text-form-control"
        type="text"
        formControlName="title"
        [placeholder]="field.baseFormatDisplayName || field.displayName"
        (keydown.enter)="$event.target.blur()"
      />
    </label>
  </div>
</form>
